import useCampaign from "@/hooks/utils/useCampaign";
import { useEffect, useState } from "react";
import useMedia, {
  IUseMediaResponse,
} from "@sendsprint/ui-react/hooks/useMedia";

const SCROLL_THRESHOLD = 30;

export interface IUseHeaderResponse {
  breakPointResponse: IUseMediaResponse;
  isSolid: boolean;
  handleIntercomShow: () => void;
  loginLink: string;
  registerLink: string;
  handleClearCampaignId: () => void;
}

const useHeader = (): IUseHeaderResponse => {
  const [isSolid, setSolid] = useState(false);
  const breakPointResponse = useMedia();
  const { loginLink, registerLink, handleClearCampaignId } = useCampaign();

  useEffect(() => {
    const handler = () =>
      window.scrollY > SCROLL_THRESHOLD
        ? !isSolid && setSolid(true)
        : isSolid && setSolid(false);

    handler();

    document.addEventListener("scroll", handler);
    return () => document.removeEventListener("scroll", handler);
  }, [isSolid]);

  const handleIntercomShow = () => {
    if (typeof window !== "undefined" && window?.zE) {
      // Check if zE is ready
      window.zE("messenger", "open");
    } else {
      console.error(
        "Zendesk Web Widget is not ready yet or running in a non-browser environment.",
      );
    }
  };

  return {
    isSolid,
    handleIntercomShow,
    breakPointResponse,
    loginLink,
    registerLink,
    handleClearCampaignId,
  };
};

export default useHeader;
